module.exports = __webpack_public_path__ + "img/S-right.bba2540d.png";